import { createContext, useContext, useEffect, useState } from "react";

export const FilteringContext = createContext(undefined);

const DEFAULT_FILTER = {
    _brands: [],
    bimClasses: [],
    brands: [],
    countries: [],
    token: "",
};

export default function FilteringProvider(props) {
    const { limit = {}, persistenceService, ...restProps } = props;

    const [filter, setFilter] = useState(persistenceService?.load?.() ?? DEFAULT_FILTER);

    useEffect(
        () => {
            Object.keys(limit).forEach(
                () => setFilter(
                    (filter) => ({ ...filter, ...limit })
                )
            );
        },
        [limit],
    );

    useEffect(
        () => {
            persistenceService?.save?.(filter);
        },
        [filter, persistenceService],
    );

    function set(key, value) {
        if (key in limit) return;
        setFilter(
            (filter) => {
                const oldValue = filter[key];
                const newValue = typeof value === "function"
                    ? value(oldValue)
                    : value;
                return {
                    ...filter,
                    [key]: newValue,
                };
            }
        );
    }

    const value = {
        ...filter,
        set,
        limit,
    };

    return (
        <FilteringContext.Provider
            value={ value }
            { ...restProps }
        />
    );
}

export function useFiltering() {
    return useContext(FilteringContext);
}
